import React from 'react'
import { Loader2, ExternalLink } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { trpc } from '@/trpcReact'
import { toast } from 'sonner'
import * as Sentry from '@sentry/react-native'
import { PaymentMeta } from '@/constants/PaymentMeta'

import { useSubscriptions } from '@/hooks/useSubscription'

export type EmptySubscriptionListStateProps = {
  currentSubscriptions?: ReturnType<typeof useSubscriptions>['data']
}

type Plan = 'personal' | 'team'

export const BuySubscription = ({ currentSubscriptions }: EmptySubscriptionListStateProps) => {
  const [checkoutUrl, setCheckoutUrl] = React.useState<string | null>(null)
  const [selectedPlan, setSelectedPlan] = React.useState<Plan | null>(null)

  const { isPending, mutate } = trpc.createCheckoutLink.useMutation({
    onSuccess: ({ checkoutUrl }) => {
      setCheckoutUrl(checkoutUrl)
    },
    onError: (error) => {
      Sentry.captureException(error)
      toast.error(
        'Unable to create checkout link, please try again, or try the payment links at the home page.',
      )
    },
  })

  const handleGetSubscription = (plan: Plan) => {
    setCheckoutUrl(null)
    setSelectedPlan(plan)
    mutate({
      productId: PaymentMeta[plan].productId,
    })
  }

  const handleReset = () => {
    setCheckoutUrl(null)
    setSelectedPlan(null)
  }

  const hasSubs = currentSubscriptions?.length ?? 0

  const variant = hasSubs ? 'outline' : 'default'
  return (
    <div className="w-full max-w-md">
      <div className="flex flex-col py-8 gap-4">
        {checkoutUrl ? (
          <div className="flex flex-col  gap-2">
            <p className="text-sm text-muted-foreground text-center">
              Click below to proceed to the payment page for the {selectedPlan?.toLowerCase()} plan.
            </p>
            <a
              href={checkoutUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground ring-offset-background transition-colors hover:bg-primary/90 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
            >
              <ExternalLink className="h-4 w-4" />
              Open Payment Page
            </a>
            <Button variant="ghost" size="sm" onClick={handleReset}>
              Choose Different Plan
            </Button>
            <p className="text-xs text-muted-foreground text-center mt-2">
              We use Creem.io as our Merchant of record - they will process the payment.
            </p>
          </div>
        ) : (
          <div className="flex flex-col gap-4 w-full px-4 max-w-lg ">
            <h3 className="text-lg font-semibold text-center ">Add more seats to your account</h3>

            {/*<Button*/}
            {/*  variant={variant}*/}
            {/*  disabled={isPending}*/}
            {/*  className="gap-2 w-auto self-center text-center py-2 px-3 h-auto"*/}
            {/*  onClick={() => handleGetSubscription('personal')}*/}
            {/*>*/}
            {/*  {isPending && selectedPlan === 'personal' && <Loader2 className="h-4 w-4 animate-spin" />}*/}
            {/*  <span className="text-center">*/}
            {/*    <span className="font-medium text-sm sm:text-base">Get Personal subscription</span>*/}
            {/*    <span className="block text-xs">*/}
            {/*      add {PaymentMeta.personal.seats} seat, ${PaymentMeta.personal.cost}/year*/}
            {/*    </span>*/}
            {/*  </span>*/}
            {/*</Button>*/}
            <Button
              variant={variant}
              disabled={isPending}
              className="gap-2 w-auto self-center text-center py-2 px-3 h-auto"
              onClick={() => handleGetSubscription('team')}
            >
              {isPending && selectedPlan === 'team' && <Loader2 className="h-4 w-4 animate-spin" />}
              <span className="text-center">
                <span className="font-medium text-sm sm:text-base">Get Team subscription</span>
                <span className="block text-xs">
                  add {PaymentMeta.team.seats} seats, ${PaymentMeta.team.cost}/year
                </span>
              </span>
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
